import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import homepageService from "../services/homepage";
import { swalSuccess, swalError, swalDelete } from "../utils/swal";

function ManageBlocks({ session }) {
    const { t } = useTranslation();
    const [blocks, setBlocks] = useState([]);
    const [title, setTitle] = useState("");
    const [type, setType] = useState("CUSTOM");

    useEffect(() => {
        // Mock data or fetch
        fetchBlocks();
    }, []);

    const fetchBlocks = () => {
        homepageService.getBlocks(session.token).then(res => setBlocks(res.data));
    };

    const handleCreate = e => {
        e.preventDefault();
        homepageService.createBlock(session.token, { title, type }).then(res => {
            if (res.error) swalError(res.error);
            else {
                swalSuccess(t("block_created"));
                fetchBlocks();
            }
        });
    };

    const handleDelete = id => {
        swalDelete(() => {
            homepageService.deleteBlock(session.token, id).then(() => {
                swalSuccess(t("deleted"));
                fetchBlocks();
            });
        });
    };

    return (
        <div className="container mt-4">
            <h3>{t("manage_blocks_title")}</h3>

            <div className="card p-3 mb-4">
                <h5>{t("add_block")}</h5>
                <form onSubmit={handleCreate}>
                    <div className="form-group">
                        <label>{t("col_title")}</label>
                        <input className="form-control" value={title} onChange={e => setTitle(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label>{t("col_type")}</label>
                        <select className="form-control" value={type} onChange={e => setType(e.target.value)}>
                            <option value="HISTORY">{t("block_type_history")}</option>
                            <option value="RELATED">{t("block_type_related")}</option>
                            <option value="FEATURED">{t("block_type_featured")}</option>
                            <option value="CUSTOM">{t("block_type_custom")}</option>
                        </select>
                    </div>
                    <button className="btn btn-primary" type="submit">{t("add_block")}</button>
                </form>
            </div>

            <ul className="list-group">
                {blocks.map(block => (
                    <li className="list-group-item d-flex justify-content-between align-items-center" key={block._id}>
                        <div>
                            <strong>{block.title}</strong> - <span className="badge badge-info">{block.type}</span>
                        </div>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(block._id)}>{t("btn_delete")}</button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

const mapStateToProps = store => ({ session: store.session });
export default connect(mapStateToProps)(ManageBlocks);
